import { IdDocumentType } from "types/document_type";

/**
 * Document types according to country
 */

export const ecuadorDocumentTypes: IdDocumentType[] = [
  { mnemonic: "CC", description: "CI" },
  { mnemonic: "PP", description: "PASSPORT" },
  { mnemonic: "RUC", description: "RUC" },
];

export const mexicoDocumentTypes: IdDocumentType[] = [
  { mnemonic: "PP", description: "PP" },
  { mnemonic: "CURP", description: "CURP" },
  { mnemonic: "RFC", description: "RFC" },
];

export const peruDocumentTypes: IdDocumentType[] = [
  { mnemonic: "DNI", description: "DNI" },
  { mnemonic: "CE", description: "CE" },
  { mnemonic: "PAS", description: "PAS" },
];

export const colombiaDocumentTypes: IdDocumentType[] = [
  { mnemonic: "CC", description: "CC" },
  { mnemonic: "NIT", description: "NIT" },
  { mnemonic: "CE", description: "CE" },
  { mnemonic: "TI", description: "TI" },
  { mnemonic: "PP", description: "PASSPORT" },
];
export const brasilDocumentTypes: IdDocumentType[] = [
  { mnemonic: "CPF", description: "CPF" },
  { mnemonic: "CNPJ", description: "CNPJ" },
  { mnemonic: "RG", description: "RG" },
  { mnemonic: "DNI", description: "DNI" },
  { mnemonic: "CI", description: "CI" },
  { mnemonic: "CP", description: "CP" },
  { mnemonic: "RNE", description: "RNE" },
];

export const chileDocumentTypes: IdDocumentType[] = [
  { mnemonic: "RUT", description: "RUT" },
  { mnemonic: "CC", description: "CC" },
  { mnemonic: "NIT", description: "NIT" },
  { mnemonic: "TI", description: "TI" },
  { mnemonic: "PP", description: "PP" },
  { mnemonic: "CE", description: "CE" },
];

export const costaRicaDocumentTypes: IdDocumentType[] = [
  { mnemonic: "CI", description: "CI" },
  { mnemonic: "NITE", description: "NITE" },
];

export const guatemalaDocumentTypes: IdDocumentType[] = [
  { mnemonic: "DPI", description: "DPI" },
  { mnemonic: "NIT", description: "NIT" },
];

export const panamaDocumentTypes: IdDocumentType[] = [
  { mnemonic: "CIP", description: "CIP" },
  { mnemonic: "NIT", description: "NIT" },
];

export const nicaraguaDocumentTypes: IdDocumentType[] = [
  { mnemonic: "CI", description: "CI" },
  { mnemonic: "RUC", description: "RUC" },
];

export const hondurasDocumentTypes: IdDocumentType[] = [
  { mnemonic: "RNP", description: "RNP" },
  { mnemonic: "RTN", description: "RTN" },
];

export const elSalvadorDocumentTypes: IdDocumentType[] = [
  { mnemonic: "DUI", description: "DUI" },
  { mnemonic: "NIT", description: "NIT" },
];

/**
 * Currency Enumeration Document Types
 */
export enum DocumentTypesPayoutsCashEnum {
  CC = "CC",
  NIT = "NIT",
  CE = "CE",
  TI = "TI",
  PP = "PP",
}



// WEBPACK FOOTER //
// ./src/shared/DocumentTypes.ts